import InputTime from "./InputTime";

export default InputTime;
